import {Component, EventEmitter, Input, model, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {TransitDeclaration} from "@portbase/bezoekschip-service-typescriptmodels";
import moment from "moment/moment";

@Component({
  selector: 'app-transit-declaration-send-trigger-info',
  templateUrl: './transit-declaration-send-trigger-info.component.html',
  styleUrls: ['./transit-declaration-send-trigger-info.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TransitDeclarationSendTriggerInfoComponent implements OnInit {
  @Input() declaration = <TransitDeclaration>{};
  @Input() readonly: boolean = false;
  @Input() sendOnAtaEnabled: boolean = true;
  @Input() includeSealsEnabled: boolean = false;
  @Output() changed = new EventEmitter<void>();
  includeSeals = model<boolean>();

  minDate = moment();

  ngOnInit() {
    this.includeSeals.set(true);
  }

  get today(): string {
    return moment().startOf("day").toISOString()
  };

  onToggleSendOnAta = () => {
    if (this.declaration.status.sendOnAta) {
      this.declaration.status.sendDate = null;
    }

    this.changed.emit();
  }

  emitChange() {
    setTimeout(() => {
      this.changed.emit()
    }, 0);
  }

  get sendOnAta(): boolean {
    return !!this.declaration.status.sendOnAta;
  }

  set sendOnAta(value: boolean) {
    this.declaration.status.sendOnAta = value;
  }
}
